import React, { Fragment } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.css';

const PhoneInput = ({ value = '', label, useFloatingLabel, disabled = false, errorMsg = '', onChange = () => {} }) => {
  return (
    <div>
      {label && <div className={useFloatingLabel ? 'floatingInputLabel' : 'mb-2 body-12-medium'}>{label}</div>}
      <ReactPhoneInput
        inputClass={`h5-regular ${
          errorMsg ? 'errorInput' : `countryInput ant-input ant-input-lg ant-input-outlined elevate ant-input-css-var`
        }`}
        buttonClass={`countryButton`}
        country={'us'}
        placeholder="+1 (123) 456-7890"
        value={value}
        disabled={disabled}
        onChange={onChange}
      />
      {errorMsg && <div className="error-text">{errorMsg}</div>}
    </div>
  );
};

export default PhoneInput;
